import { h } from 'preact'
import { signal } from '@preact/signals'
import { Publicite } from '../publicite/publicite.jsx'

export const bandeAccueilTvState = signal('')

export const BandeAccueilTv = ({ publicite, format, elementId }) => {
   // Carrousel
   let carrousel = ''
   if (bandeAccueilTvState.value !== '' && bandeAccueilTvState.value['carrousel_n1Tv'] !== undefined) carrousel = bandeAccueilTvState.value['carrousel_n1Tv']
   return (
      <div class="row no-gutters mb-2" data-testid="bande-top-tv">
         <div class="col-12 col-lg-8">{carrousel !== '' ? <harmony-carrousel-legacy format={format} slides={JSON.stringify(carrousel.slides)} elementId={elementId} /> : ''}</div>
         <div class="col-4 d-none d-lg-block">
            <div class="d-flex align-items-center bg-gray2 h-100">
               <Publicite adsId={publicite.rmAdsId} type="rm" />
            </div>
         </div>
      </div>
   )
}
